export default __webpack_public_path__ + "static/media/CRO.a7c3993c.png";